<template>
  <router-view/>
</template>

<script>

export default {
  name: 'App',
}
</script>

<style>
*{
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
ul,li{
  list-style: none;
}
</style>
